import { IStandardsSetListViewModel } from "../../types/IStandardsSetListViewModel";
import { IStandardsSetsFetchResponse } from "../../types/IStandardsSetsFetchResponse";

export function convertStandardsSetsFetchToViewModel(
  data: IStandardsSetsFetchResponse[],
): IStandardsSetListViewModel[] {
  return data.length > 0
    ? data.map((set) => ({
        id: set.id,
        title: set.title,
        viewmodel_type: set.viewmodel_type,
        children: set.children.map((child) => ({
          content_id: child.id,
          content_type: child.metadata.content_type,
          description: child.description || "",
          title: "",
          total_content_tagged: 0,
          display_fields: {
            authority_description: "",
            document_adopt_year: Number(child.metadata.document_adopt_year),
            document_primary_subject: child.metadata.document_primary_subject,
            grades: child.metadata.grades,
            number_enhanced: child.metadata.number_enhanced,
            number_prefix_enhanced: child.metadata.number_prefix_enhanced,
            regions: child.metadata.region_codes,
            standard_type: null,
            status: "",
          },
        })),
      }))
    : [];
}
